export default "__VITE_ASSET__CCfk$j2E__"